/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Subtitle_Export_DescriptionInputs */

const en_batch_subtitle_export_description = /** @type {(inputs: Batch_Subtitle_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select event groups and export formats to batch export subtitles`)
};

const fr_batch_subtitle_export_description = /** @type {(inputs: Batch_Subtitle_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez des groupes d’événements et des formats d’export pour exporter les sous-titres par lot`)
};

const de_batch_subtitle_export_description = /** @type {(inputs: Batch_Subtitle_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisgruppen und Exportformate auswählen, um Untertitel stapelweise zu exportieren`)
};

const it_batch_subtitle_export_description = /** @type {(inputs: Batch_Subtitle_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona gruppi di eventi ed esporta formati per esportare in batch i sottotitoli`)
};

const ru_batch_subtitle_export_description = /** @type {(inputs: Batch_Subtitle_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите группы событий и форматы экспорта для пакетного экспорта субтитров.`)
};

const es_batch_subtitle_export_description = /** @type {(inputs: Batch_Subtitle_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione grupos de eventos y formatos de exportación para exportar subtítulos por lotes`)
};

const zh_cn2_batch_subtitle_export_description = /** @type {(inputs: Batch_Subtitle_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择事件组和导出格式，批量导出字幕。`)
};

const ja_batch_subtitle_export_description = /** @type {(inputs: Batch_Subtitle_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループとエクスポート形式を選択して字幕を一括エクスポートします`)
};

const hi_batch_subtitle_export_description = /** @type {(inputs: Batch_Subtitle_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षकों को बैच में निर्यात करने के लिए इवेंट समूह और निर्यात प्रारूप चुनें।`)
};

const pt_pt2_batch_subtitle_export_description = /** @type {(inputs: Batch_Subtitle_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione grupos de eventos e formatos de exportação para exportar legendas em lote.`)
};

/**
* | output |
* | --- |
* | "Select event groups and export formats to batch export subtitles" |
*
* @param {Batch_Subtitle_Export_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_subtitle_export_description = /** @type {((inputs?: Batch_Subtitle_Export_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Subtitle_Export_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_batch_subtitle_export_description(inputs)
	if (locale === "de") return de_batch_subtitle_export_description(inputs)
	if (locale === "it") return it_batch_subtitle_export_description(inputs)
	if (locale === "ru") return ru_batch_subtitle_export_description(inputs)
	if (locale === "es") return es_batch_subtitle_export_description(inputs)
	if (locale === "zh-CN") return zh_cn2_batch_subtitle_export_description(inputs)
	if (locale === "ja") return ja_batch_subtitle_export_description(inputs)
	if (locale === "hi") return hi_batch_subtitle_export_description(inputs)
	if (locale === "pt-PT") return pt_pt2_batch_subtitle_export_description(inputs)
	return en_batch_subtitle_export_description(inputs)
});